'use client';

import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "component", "invisible", "open", "components", "componentsProps", "slotProps", "slots", "TransitionComponent", "transitionDuration"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import clsx from 'clsx';
import composeClasses from '@mui/utils/composeClasses';
import { styled } from "../zero-styled/index.js";
import { useDefaultProps } from "../DefaultPropsProvider/index.js";
import useSlot from "../utils/useSlot.js";
import Fade from "../Fade/index.js";
import { getBackdropUtilityClass } from "./backdropClasses.js";
import { jsx as _jsx } from "react/jsx-runtime";

var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
      invisible = ownerState.invisible;
  var slots = {
    root: ['root', invisible && 'invisible']
  };
  return composeClasses(slots, getBackdropUtilityClass, classes);
};

var BackdropRoot = styled('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent',
  variants: [{
    props: {
      invisible: true
    },
    style: {
      backgroundColor: 'transparent'
    }
  }]
});
var Backdrop = /*#__PURE__*/React.forwardRef(function Backdrop(inProps, ref) {
  var props = useDefaultProps({
    props: inProps,
    name: 'MuiBackdrop'
  });

  var children = props.children,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'div' : _props$component,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      _props$components = props.components,
      components = _props$components === void 0 ? {} : _props$components,
      _props$componentsProp = props.componentsProps,
      componentsProps = _props$componentsProp === void 0 ? {} : _props$componentsProp,
      _props$slotProps = props.slotProps,
      slotProps = _props$slotProps === void 0 ? {} : _props$slotProps,
      _props$slots = props.slots,
      slots = _props$slots === void 0 ? {} : _props$slots,
      TransitionComponentProp = props.TransitionComponent,
      transitionDuration = props.transitionDuration,
      other = _objectWithoutProperties(props, _excluded);

  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    component: component,
    invisible: invisible
  });

  var classes = useUtilityClasses(ownerState);

  var backwardCompatibleSlots = _objectSpread({
    transition: TransitionComponentProp,
    root: components.Root
  }, slots);

  var backwardCompatibleSlotProps = _objectSpread(_objectSpread({}, componentsProps), slotProps);

  var externalForwardedProps = {
    slots: backwardCompatibleSlots,
    slotProps: backwardCompatibleSlotProps
  };

  var _useSlot = useSlot('root', {
    elementType: BackdropRoot,
    externalForwardedProps: externalForwardedProps,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }),
      _useSlot2 = _slicedToArray(_useSlot, 2),
      RootSlot = _useSlot2[0],
      rootProps = _useSlot2[1];

  var _useSlot3 = useSlot('transition', {
    elementType: Fade,
    externalForwardedProps: externalForwardedProps,
    ownerState: ownerState
  }),
      _useSlot4 = _slicedToArray(_useSlot3, 2),
      TransitionSlot = _useSlot4[0],
      transitionProps = _useSlot4[1];

  return /*#__PURE__*/_jsx(TransitionSlot, _objectSpread(_objectSpread(_objectSpread({
    in: open,
    timeout: transitionDuration
  }, other), transitionProps), {}, {
    children: /*#__PURE__*/_jsx(RootSlot, _objectSpread(_objectSpread({
      "aria-hidden": true
    }, rootProps), {}, {
      classes: classes,
      ref: ref,
      children: children
    }))
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default Backdrop;